export enum PTabsAlign {
  JUSTIFY = 'justify',
  LEFT = 'left',
}
